import { Injectable } from '@angular/core';
import { formatDate, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/fr';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeJp from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localePt from '@angular/common/locales/pt';
import localePtPt from '@angular/common/locales/pt-PT';
import localeRu from '@angular/common/locales/ru';
import localeSv from '@angular/common/locales/sv';
import localeZhHans from '@angular/common/locales/zh-Hans';
import localeZhHant from '@angular/common/locales/zh-Hant';
import { ConfigService } from './config.service';

@Injectable({
	providedIn: 'root'
})
export class DateFormatService {
	private currentLocale: string;

	constructor(private configService: ConfigService) {
		registerLocaleData(localeDe);
		registerLocaleData(localeEnGb);
		registerLocaleData(localeEn);
		registerLocaleData(localeEs);
		registerLocaleData(localeFr);
		registerLocaleData(localeIt);
		registerLocaleData(localeJp);
		registerLocaleData(localeKo);
		registerLocaleData(localePt);
		registerLocaleData(localePtPt);
		registerLocaleData(localeRu);
		registerLocaleData(localeSv);
		registerLocaleData(localeZhHans, 'zh-CN');
		registerLocaleData(localeZhHant, 'zh-TW');

		this.currentLocale = this.configService.config.defaultLanguage;
	}

	/**
	 * Setzt die aktuelle Locale
	 *
	 * @param locale locale
	 */
	setLocale(locale: string) {
		this.currentLocale = locale;
	}

	/**
	 * Formatiert ein Datum
	 *
	 * @param date Date
	 * @param formatStyle formatStyle, see https://angular.io/api/common/DatePipe
	 */
	public formatDate(date: Date, formatStyle = 'shortDate') {
		return formatDate(date, formatStyle, this.currentLocale);
	}
}
